export default {
  data: () => ({
    gatewayError: '',
    loaderPay: false
  }),
  methods: {
    createSource (gateway, client = null) {
      return new Promise((resolve, reject) => {
        const payload = {
          gateway: gateway,
          payment: this.payment.id,
          amount: this.payment.amount,
          usage: 'single'
        }
        if (client) {
          payload.client = client
        }
        if (this.payment.customer) {
          payload.customer = this.payment.customer.id
        }
        this.$store.dispatch('payments/CREATE', {
          resource: 'sources',
          payload: payload,
          headers: {
            headers: {
              'x-simple-workspace': this.payment.account.id
            }
          }
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    authorizePayment () {
      return new Promise((resolve, reject) => {
        const payload = {
          source: this.source.id
        }
        if (this.payment.invoice) {
          payload.invoice = this.payment.invoice.id
        }
        this.$store.dispatch('payments/CREATE', {
          resource: 'payments',
          id: this.payment.id,
          detail: 'authorize',
          payload: payload
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    capturePayment () {
      return new Promise((resolve, reject) => {
        this.$store.dispatch('payments/RETRIEVE', {
          resource: 'payments',
          id: this.payment.id,
          detail: 'capture'
        })
        .then(() => {
          resolve()
        })
        .catch((error) => {
          reject(error)
        })
      })
    },
    async payExternalGateway (gateway) {
      try {
        this.loaderPay = true
        await this.createSource(gateway)
        await this.authorizePayment()
        window.location.replace(this.paymentsDetail.links.process_url)
      } catch (error) {
        this.gatewayError = error
      } finally {
        this.loaderPay = false
      }
    }
  }
}